import React, { Component } from 'react';
import { PropTypes as RPT } from 'prop-types';

export default class Term extends Component {
  static propTypes = {
    title: RPT.string,
    field: RPT.string,
    url: RPT.string,
  }

  termUrl() {
    /* eslint max-len: ["error", { "code": 150 }] */
    return `${window.location.protocol}//${window.location.host}${window.location.pathname}${this.props.url}`;
  }

  onClick(event) {
    event.preventDefault();
    $('#term').modal({ remote: this.termUrl(), show: false });
  }

  render() {
    const { title, field } = this.props;

    return (
      <a
        ref="link"
        href={this.termUrl()}
        onClick={event => this.onClick(event)}
        className="product-box wide product-box--dictionary"
      >
        <div className="inner">
          <h5>{title}</h5>
          <div className="dictionary-term" dangerouslySetInnerHTML={{ __html: field }} />
        </div>
      </a>
    );
  }
}
